import React from 'react';
 const Error = () => {
     return <h1>Opps Page not found!</h1>;
 };
 export default Error;